import type { Language } from '@/bindings/Language'
import { Field, Input } from '@/components/field'
import type { NameDraft } from '@/features/back-office/name-draft'
import { LANGUAGE_NAMES } from '@/lib/i18n/languages'
import { useT } from '@/lib/i18n/translate'

/**
 * One name input per shown language, the main one required (T4.5). `error` lands on the
 * main field: the only one the backend can refuse (MISSING_MAIN_LANGUAGE).
 */
export function LocalizedNameFields({
  value,
  onChange,
  main,
  languages,
  error,
  autoFocus,
}: {
  value: NameDraft
  onChange: (next: NameDraft) => void
  main: Language
  languages: readonly Language[]
  error?: unknown
  autoFocus?: boolean
}) {
  const t = useT()
  return (
    <>
      {languages.map((language) => (
        <Field
          key={language}
          label={t('menu.nameFor', { language: LANGUAGE_NAMES[language] })}
          hint={language === main ? t('menu.nameMain') : t('common.optional')}
          error={language === main ? error : undefined}
        >
          <Input
            required={language === main}
            autoFocus={autoFocus && language === main}
            value={value[language]}
            onChange={(e) => onChange({ ...value, [language]: e.target.value })}
          />
        </Field>
      ))}
    </>
  )
}
